import { render, staticRenderFns } from "./ProductCombinationTabs.vue?vue&type=template&id=6ba3befa&scoped=true"
import script from "./ProductCombinationTabs.vue?vue&type=script&lang=ts"
export * from "./ProductCombinationTabs.vue?vue&type=script&lang=ts"
import style0 from "./ProductCombinationTabs.vue?vue&type=style&index=0&id=6ba3befa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3befa",
  null
  
)

export default component.exports